


























import {
    defineComponent,
    reactive,
    watch,
    PropType,
} from '@vue/composition-api';

import { parseText } from './parseText';
import { EMOJI_CONFIGS_MAP, emojiRegExp } from './emoji';

export default defineComponent({
    name: 'RichContentWithEmoji',
    props: {
        content: {
            type: String,
            default: '',
        },
        highLightMap: {
            type: Object as PropType<Record<string, any>>,
            default: () => ({}),
        },
        maxLines: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER,
        },
    },
    setup(props) {
        const state = reactive({
            parsedContent: [] as ReturnType<typeof parseText>,
        });

        watch(
            () => props.content,
            () => {
                try {
                    state.parsedContent = parseText(props.content);
                } catch (err) {
                    console.log('err', err);
                }
            },
            {
                immediate: true,
            }
        );

        return {
            props,
            state,

            EMOJI_CONFIGS_MAP,
            emojiRegExp,
        };
    },
});
